function updateShipping(cart) {
  const shippingWrapper = document.querySelector('[data-free-shipping]');
  const threshold = +shippingWrapper.dataset.threshold;
  let html;
  if (cart.total_price >= threshold) {
    html = `<p class="cart__shipping__free">${window.theme.strings.freeShipping}</p>`
  } else {
    const remaining = `<span>${Shopify.formatMoney(Math.abs(cart.total_price - threshold), theme.settings.moneyFormat)}</span>`
    html = `<p class="cart__shipping__remaining">${window.theme.strings.remainingShipping.replace('AMOUNT', remaining)}</p>`
  }
  shippingWrapper.innerHTML = html
}

document.addEventListener('cart:updated', function (evt) {
  updateShipping(evt.detail.cart);
});

document.addEventListener('ajaxProduct:added', function (evt) {
  theme.cart.getCart().then(cart => {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: cart
      }
    }));
  })
});

document.addEventListener('ajaxProduct:added', function (evt) {
  addedToCart = document.querySelector('[data-added-to-cart]')

  addedToCart.style.transform = "translateY(44px)"
  addedToCart.style.opacity = "1"

  const closeAddedToCart = setTimeout(close, 5000);
  function close() {
    addedToCart.style.transform = "translateY(88px)"
    addedToCart.style.opacity = "0"
  }

  console.log(evt.detail.product);
});

var swiper = new Swiper(".featured-collection-swiper", {
  slidesPerView: 2,
  spaceBetween: 7,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 14,
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 7,
        spaceBetween: 22,
      }
    },
});